import { useEffect, useState } from 'react';
/** Match Antd's default screen breakpoints */
export const BP = {
    xs: 480,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1600,
};
function query(key) {
    return `(max-width: ${BP[key] - 1}px)`;
}
/** true when viewport is BELOW the given breakpoint (i.e. "smaller than lg" etc.) */
export function useIsBelow(bp) {
    const [match, setMatch] = useState(() => typeof window !== 'undefined' ? window.matchMedia(query(bp)).matches : false);
    useEffect(() => {
        const mql = window.matchMedia(query(bp));
        const handler = (e) => setMatch(e.matches);
        if (mql.addEventListener)
            mql.addEventListener('change', handler);
        else
            mql.addListener(handler);
        setMatch(mql.matches);
        return () => {
            if (mql.removeEventListener)
                mql.removeEventListener('change', handler);
            else
                mql.removeListener(handler);
        };
    }, [bp]);
    return match;
}
/** Convenience aliases matching common needs */
export const useIsMobile = () => useIsBelow('md'); // <768
export const useIsTablet = () => useIsBelow('lg'); // <992
